export const formatPrice = (price: number, lang: string, currency: string | undefined): string =>
  Intl.NumberFormat(lang.replace('_', '-'), {
    style: 'currency',
    currency: currency || 'EUR',
    minimumFractionDigits: 2
  }).format(price)

export const currencySymbol = (lang: string, currency: string): string =>
  formatPrice(0, lang, currency).replace(/[\d,.]/g, '')

// export const discountPricingValidation = (
//   priceBreakdown: GroupedPriceBreakdown,
//   groupPriceBreakDown: GroupPriceBreakdown | null,
//   isVasDiscountEnabled: boolean,
//   isTotal: boolean
// ) => {
//   const calculateAverage = (values: number[]) => values.reduce((acc, value) => acc + value, 0) / values.length

//   const maximumDiscoutPercentageAllowed = calculateAverage(
//     priceBreakdown.groups.map(group => group.maximumSalesPricePercentageWithoutApproval)
//   )

//   // const totalAnnualListPrice =
//   //   priceBreakdown.coreOfferingAnnualListPrice + priceBreakdown.valueAddedServicesAnnualListPrice
//   const totalAnnualListPrice =
//     priceBreakdown.coreOfferingAnnualListPrice
//   const totalPriceWithExtraService = priceBreakdown.annualListPrice

//   // const groupAnnualListPrice = isVasDiscountEnabled
//   //   ? groupPriceBreakDown?.coreOfferingVasDiscountListPrice || 0
//   //   : groupPriceBreakDown?.coreOfferingAnnualListPrice || 0
//   const groupAnnualListPrice = groupPriceBreakDown?.coreOfferingAnnualListPrice || 0
//   // const groupAnnualPriceWithExtraService = isVasDiscountEnabled
//   //   ? groupPriceBreakDown?.annualListPrice || 0
//   //   : groupPriceBreakDown?.annualListPriceWithExtraServices || 0
//   // const groupAnnualPriceWithExtraService = isVasDiscountEnabled
//   //   ? groupPriceBreakDown?.annualListPrice || 0
//   //   : groupPriceBreakDown?.annualListPriceWithExtraServices || 0

//   // const annualListPrice = isTotal && isVasDiscountEnabled ? totalAnnualListPrice : groupAnnualListPrice
//   const annualListPrice = isTotal ? totalAnnualListPrice : groupAnnualListPrice

//   // const annualPriceWithExtraService =
//   //   isTotal && isVasDiscountEnabled ? totalPriceWithExtraService : groupAnnualPriceWithExtraService

//   const validatePercentage = 100 - ((annualPriceWithExtraService - annualListPrice) / annualPriceWithExtraService) * 100
//   return { maximumDiscoutPercentageAllowed, validatePercentage }
// }
